module.exports = __webpack_public_path__ + "static/media/img_16.c48fe4d5.png";